import React, {
  useState,
  useContext,
  useEffect
} from 'react';

import {
  withRouter
} from 'react-router-dom';

import
  PropTypes
from 'prop-types';

import
  VettingDropDown
from 'src/Components/Common/VettingDropDown/VettingDropDown';

import
  VettingInput
from 'src/Components/Common/VettingInput/VettingInput';

import
  KeyValueDataComponent
from 'src/Components/CreditVetting/KeyValueDataComponent/KeyValueDataComponent';

import {
  SalesContext
} from 'src/Context/SalesContext';

import {
  FormFieldLabel,
  HorizontalLine
} from 'src/StyledComponents';


import {
  checkInputValidity,
  getKeyValueData,
  createArray,
  registerEnterEvent
} from '../../../Utility/utility';

import {
  validateBankDetailsService,
  submitLead,
  getBranchCodeService
} from 'src/Services/Services';

import
  ErrorPopup
from 'src/Components/Common/ErrorPopup/ErrorPopup';

import {
  tagOnErrorScreen,
  tagOnBankInfoError,
  tagOnDebiCheckNewCustomer
} from 'src/Tagging/NewCustomerTagging';

import
  DebiCheck
from 'src/Components/Common/DebiCheck/DebiCheck';

import './VettingBankDetails.css';

const createFormComponents = (details, dropDownValues, isHideBankYrs) => {

  const accountTypeArray = dropDownValues.BANK_ACCOUNT_TYPE.map(item => item.name);
  const debitOrderDateArray = dropDownValues.DEBIT_ORDER_DATE.map(item => item.name);
  const bankListArray = dropDownValues.BANK_LIST.map(item => item.bankName);

  const renderedComponents = {
    bankName: {
      name: 'Bank name',
      type: 'dropDown',
      value: details?.bankName?.value || '',
      options: bankListArray || [],
      width: 65,
      validations: {
        required: true,
        invalidMessage: 'Please select your bank',
      },
      config: {
        type: 'select',
        required: true,
        placeholder: 'Select bank name',
        tabIndex: '51'
      },
      isValid: false,
      isTouched: false
    },
    branchCode: {
      name: 'Branch code',
      type: 'input',
      value: details?.branchCode?.value || '',
      width: 30,
      validations: {
        required: true,
        type: 'number',
        invalidMessage: 'Please enter your branch code',
      },
      config: {
        type: 'number',
        required: true,
        placeholder: 'Add branch code',
        tabIndex: '52'
      },
      isValid: false,
      isTouched: false
    },
    accountType: {
      name: 'Account type',
      type: 'dropDown',
      value: details?.accountType?.value || '',
      options: accountTypeArray || ['Current', 'Savings', 'Transmission'],
      width: 100,
      validations: {
        required: true,
        invalidMessage: 'Please select your bank',
      },
      config: {
        type: 'select',
        required: true,
        placeholder: 'Select account type',
        tabIndex: '53'
      },
      isValid: false,
      isTouched: false
    },
    accountNumber: {
      name: 'Account number',
      type: 'input',
      value: details?.accountNumber?.value || '',
      width: 100,
      validations: {
        required: true,
        type: 'number',
        invalidMessage: 'Please enter valid account number',
      },
      config: {
        type: 'number',
        required: true,
        placeholder: 'Add account number',
        tabIndex: '54'
      },
      isValid: false,
      isTouched: false
    },
    accountHolderName: {
      name: 'Account holder name',
      type: 'input',
      value: details?.accountHolderName?.value || '',
      width: 100,
      validations: {
        required: true,
        invalidMessage: 'Please enter the account holder name',
      },
      config: {
        required: true,
        placeholder: 'Add account holder name',
        tabIndex: '55'
      },
      isValid: false,
      isTouched: false
    },
    debitOrderDate: {
      name: 'Preferred debit order date',
      type: 'dropDown',
      value: details?.debitOrderDate?.value || '1st',
      options: debitOrderDateArray || ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'],
      width: 100,
      validations: {
        required: true,
        invalidMessage: 'Please select the debit order date you\'d prefer',
      },
      config: {
        type: 'select',
        required: true,
        placeholder: 'Select preferred debit order date',
        tabIndex: '56'
      },
      isValid: true,
      isTouched: true
    },
  };

  if (!isHideBankYrs) {

    renderedComponents.bankAccountYearsOpen = {
      name: 'How long have you had this bank account?',
      type: 'input',
      value: details?.bankAccountYearsOpen?.value || '',
      width: 50,
      labelWidth: '200%',
      validations: {
        required: true,
        type: 'number',
        invalidMessage: 'Please enter the valid years',
      },
      config: {
        type: 'number',
        required: true,
        placeholder: 'Enter years',
        tabIndex: '57'
      },
      isValid: false,
      isTouched: false
    };

    renderedComponents.bankAccountMonthsOpen = {

      name: 'months?',
      type: 'dropDown',
      hideLabel: true,
      value: details?.bankAccountMonthsOpen?.value || '',
      options: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11'],
      width: 50,
      validations: {
        required: true,
        invalidMessage: 'Please select the valid months',
      },
      config: {
        type: 'select',
        required: true,
        placeholder: 'Select month',
        tabIndex: '58'
      },
      isValid: false,
      isTouched: false
    };
  }

  return renderedComponents;
};

const VettingBankDetails = (props) => {

  const context = useContext(SalesContext);
  const [bankErrorMsg, setBankErrorMsg] = useState('');
  const bankDetails = context.vettingCreditDetails.bankDetails;
  const personalDetails = context.vettingCreditDetails.personalDetails;
  const contactDetails = context.vettingCreditDetails.contactDetails;
  const employmentDetails = context.employmentDetails;
  const dropDownValues = context.dropDownValues;
  const [bankDetailsApiCheck, setBankDetailsApiCheck] = useState(true);
  const [invalidBankDetails, setInvalidBankDetails] = useState(false);
  const isHideBankYrs = context.userExistingProperties['hideBankYears'];
  const [formData, setFormData] = useState({
    // Form Fields
    formComponents: createFormComponents(bankDetails, dropDownValues, isHideBankYrs),
    isFormValid: false
  });

  // Create array
  let formCompArray = createArray(formData.formComponents);
  registerEnterEvent()

  const closePopup = () => {
    setInvalidBankDetails(false);
  }

  useEffect(() => {

    if (props.isEditModeOn) {

      const formCompsCopy = { ...formData.formComponents };
      for (let key in bankDetails) {

        if (bankDetails[key] === '')
          continue;

        const changedComponent = { ...formCompsCopy[key] };
        if (Object.keys(changedComponent).length !== 0) {

          changedComponent.value = bankDetails[key].value;

          changedComponent.isValid = checkInputValidity(
            changedComponent.value,
            changedComponent.validations
          );

          changedComponent.isTouched = true;

          formCompsCopy[key] = changedComponent;
        }
      }

      const isFormValid = !Object.keys(formCompsCopy).find(e => formCompsCopy[e].isValid === false) ? true : false;
      setFormData({
        formComponents: formCompsCopy,
        isFormValid: isFormValid
      });

      if (isFormValid) {
        props.toggleNext(true);
      } else {
        props.toggleNext(false);
      }
    }
  }, [props.isEditModeOn])

  const formComponentChangeHandler = async (event, inputIdentifier) => {

    setBankDetailsApiCheck(true);
    const formCompsCopy = { ...formData.formComponents };
    const changedComponent = { ...formCompsCopy[inputIdentifier] };
    changedComponent.value = event;

    if (changedComponent.validations.readOnly)
      return;

    if (changedComponent.validations.type === 'number') {
      let lastChar = changedComponent.value.slice(-1);
      if (isNaN(lastChar)) {
        return false;
      }
    }

    changedComponent.isValid = checkInputValidity(
      changedComponent.value,
      changedComponent.validations
    );

    changedComponent.isTouched = true;
    let changedComponent2 = { ...formCompsCopy['branchCode'] };
    if (inputIdentifier === 'bankName') {

      context.setShowSpinner(true);
      let branchCode;
      try {
        branchCode = await getBranchCodeService(event);
      } catch (err) {
        console.log(err);
      }
      context.setShowSpinner(false);
      changedComponent2.value = branchCode;
      changedComponent2.isTouched = true;
      changedComponent2.isValid = true;
    }

    const newFormComps = {

      ...formCompsCopy,
      [inputIdentifier]: changedComponent,
      branchCode: inputIdentifier === 'branchCode' ? changedComponent : changedComponent2
    }

    const isFormValid = !Object.keys(newFormComps).find(e => newFormComps[e].isValid === false) ? true : false;

    setFormData({

      formComponents: newFormComps,
      isFormValid: isFormValid
    });

    if (isFormValid && bankDetailsApiCheck) {

      props.toggleNext(true);
    } else {

      props.toggleNext(false);
    }
  };

  const saveDetails = () => {

    const accountTypMap = {
      Current: '1-Current',
      Savings: '2-Savings',
      Transmission: '3-Transmission'
    }

    if (!(props.enableNext && bankDetailsApiCheck)) {

      return;
    }
    context.setShowSpinner(true);

    let payload = {
      accountNumber: formData?.formComponents?.accountNumber?.value.trim(),
      accountType: accountTypMap[formData?.formComponents?.accountType?.value].trim(),
      bankName: formData?.formComponents?.bankName?.value.trim(),
      branchCode: formData?.formComponents?.branchCode?.value.trim(),
      surnameCompName: personalDetails?.surname?.value.trim(),
      idCompRegNo: employmentDetails.selectedIdTab === 'idNumber' ? (employmentDetails?.idNumber.trim()) : (employmentDetails.passportNumber.trim()),
      idType: employmentDetails.selectedtab === 'idNumber' ? 'SID' : 'FPP',
    };

    validateBankDetailsService(payload)
      .then(res => {

        context.setShowSpinner(false);
        if (res.result.toLowerCase() === 'y') {
          const keyValueData = getKeyValueData(formData.formComponents);
          if (keyValueData['bankAccountYearsOpen']) {
            let tempObj = {
              label: 'Account Since',
              value: `${keyValueData['bankAccountYearsOpen'].value} years ${keyValueData['bankAccountMonthsOpen'].value} months`
            }
            keyValueData['accountSince'] = tempObj;
          }
          context.setVettingDetails('bankDetails', keyValueData);
          props.onNextClick(keyValueData);

        } else {
          setBankErrorMsg('invalidData');
          setBankDetailsApiCheck(false);
          setInvalidBankDetails(true);
          tagOnBankInfoError('There seems to be a problem with your bank account details. Please check that the details you\'ve entered are correct and try again');
        }
      })
      .catch(_error => {
        validateBankDetailsService(payload)
          .then(res => {
            context.setShowSpinner(false);
            if (res.result.toLowerCase() === 'y') {
              const keyValueData = getKeyValueData(formData.formComponents);
              context.setVettingDetails('bankDetails', keyValueData);
              props.onNextClick(keyValueData);
            } else {
              setBankErrorMsg('invalidData')
              setBankDetailsApiCheck(false);
              setInvalidBankDetails(true);
              tagOnBankInfoError('There seems to be a problem with your bank account details. Please check that the details you\'ve entered are correct and try again');
            }
          })
          .catch(_error => {

            submitLead(context).then(res => {
              let userDetailsObject = {
                firstName: personalDetails?.firstName?.value,
                lastName: personalDetails?.surname?.value,
                email: contactDetails?.email?.value,
                referenceNo: res.result.referenceNumber,
                contactNumber: contactDetails?.cellPhoneNo?.value,
                quoteNumber: '',
              }
              context.setUserDetailsObject(userDetailsObject);
              window.scrollTo(0, 0);
              props.history.push('/cloud/fibre/sales/success');
              context.setShowSpinner(false);
            }).catch(_error => {
              tagOnErrorScreen('A technical glitch has prevented us from submitting your details.Please contact our Customer Care on 082 1904');
              window.scrollTo(0, 0);
              props.history.push('/cloud/fibre/sales/error');
              context.setShowSpinner(false);
            })
          })
      })
  }

  return (

    <React.Fragment>

      <div className="vetting-main-section-wrapper">

        { bankDetails && !props.isEditModeOn

          ? <KeyValueDataComponent data={bankDetails} />

          : <React.Fragment>

            <div className="vetting-pd-wrapper">
              {
                formCompArray.map(item => {

                  return (
                    
                    <div className={`input-field-wrapper-${item.config.width}`} key={item.key}>

                      <FormFieldLabel
                        hide={item?.config?.hideLabel ? 1 : 0}
                        labelWidth={item?.config?.labelWidth}
                        automationidattr={`bankDetails${item.config.name}`}>

                        {item.config.name}
                      </FormFieldLabel>

                      { item.config.type === 'input'

                        ? <VettingInput
                            {...item.config}
                            updateValue={formComponentChangeHandler}
                            inputIdentifier={item.key}
                            automationidattr={item.key}
                          />
                        : null
                      }

                      { item.config.type === 'dropDown' 

                        ?  <VettingDropDown
                            selectedValue={item.config.value}
                            placeholder={item.config.config.placeholder}
                            options={item.config.options}
                            updateSelectedOption={formComponentChangeHandler}
                            inputIdentifier={item.key}
                            automationidattr={item.key}
                            isSearchable={item.key === 'bankName' ? true : false}
                          />
                        : null
                      }
                    </div>
                  )
                })
              }
            </div>

            <HorizontalLine spacing="0.75rem" />

            {/* Debi Check */}
            <DebiCheck
              setDebiCheck={() => {
                if (!context.debiCheckSelected) {
                  tagOnDebiCheckNewCustomer()
                }
                context.setDebiCheckSelected(!context.debiCheckSelected);
              }}
              value={context.debiCheckSelected}/>

            { props.showBody
              ? <div className="vetting-next-wrapper">

                  <button
                    className={`vetting-section-next-button ${(props.enableNext && bankDetailsApiCheck) ? 'next-enabled' : ''}`}
                    onClick={() => saveDetails()}
                    disabled={(props.enableNext && bankDetailsApiCheck) ? '' : 'disabled'}>
                    Next
                  </button>
                </div>

              : null
            }
          </React.Fragment>
        }
      </div>

      { invalidBankDetails &&

        <ErrorPopup
          onCancelClick={closePopup}
          onOkayClick={closePopup}>

          <span >
            { bankErrorMsg === 'invalidData'

              ? <React.Fragment>
                  <div>There seems to be a problem with your bank account details.</div>
                  <div>Please check that the details you&apos;ve entered are correct and try again</div>
                </React.Fragment>

              : <React.Fragment>
                  <div>Oops! Something went wrong and we can’t help you right now.</div>
                  <div>Please try again later.</div>
                </React.Fragment>
            }
          </span>
        </ErrorPopup>
      }
    </React.Fragment>
  )
}

VettingBankDetails.propTypes = {
  enableNext: PropTypes.bool,
  isEditModeOn: PropTypes.bool,
  onNextClick: PropTypes.func,
  showBody: PropTypes.bool,
  toggleNext: PropTypes.func,
}

export default withRouter(VettingBankDetails);